import styled from 'styled-components';

const Label = styled.span`
  font-weight: bold;
  display: block;
  margin-bottom: 1rem;
`;

export default Label;
